module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.get_class()
  }, [_c('div', {
    staticClass: "grid-two pointer",
    on: {
      "click": function (e) { return _vm.toggleInclude(e); }
    }
  }, [_c('div', [_c('div', {
    staticClass: "mb3 f4"
  }, [_c('span', {
    staticClass: "cera-round-pro-medium"
  }, [_vm._v(_vm._s(_vm.$t('titles.claimsid', {
    claimsid: 'Claim'
  })) + " #" + _vm._s(_vm.id))]), _vm._v(" "), _c('span', {
    staticClass: "cera-round-pro-medium"
  }, [_c('small', {
    staticClass: "loss-type-label cera-round-pro",
    style: (_vm.get_label_style())
  }, [_vm._v("\n            " + _vm._s(_vm.status_text) + "\n          ")])])]), _vm._v(" "), _c('div', [_c('div', [_c('a', {
    staticClass: "no-underline black",
    attrs: {
      "href": _vm.urlToViewClaimDetail()
    }
  }, [_vm._m(0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "f6 silver inter toggle-info"
  }, [_c('span', [_vm._v(_vm._s(_vm.filed_days_ago))]), _vm._v(" "), _c('img', {
    staticClass: "chevron",
    class: {
      'chevron-rotate': _vm.includeOpen
    },
    attrs: {
      "alt": "Chevron",
      "src": "/static/appicons/Chevron.svg"
    }
  })])]), _vm._v(" "), (_vm.includeOpen) ? _c('hr', {
    staticClass: "center mv3"
  }) : _vm._e(), _vm._v(" "), (_vm.includeOpen) ? _c('div', [_c('div', {
    staticClass: "f6 silver inter mb3"
  }, [_vm._v("AFFECTED DEVICES")]), _vm._v(" "), _vm._l((_vm.claimDevices), function(claim_device) {
    return _c('div', {
      key: claim_device.id
    }, [_c('a', {
      staticClass: "no-underline black",
      attrs: {
        "href": _vm.urlToViewClaimDeviceAffected(claim_device.claim_device_id)
      }
    }, [_c('div', {
      staticClass: "grid-two hover-grey-bg"
    }, [_c('div', {
      staticClass: "hov pt-15"
    }, [_c('div', {
      staticClass: "d-inline w-50-px"
    }, [_c('img', {
      staticClass: "img-responsive v-mid mr2 mb1",
      class: _vm.icon(claim_device.type) !== '' ? 'icon-affected-item' : '',
      attrs: {
        "src": _vm.icon(claim_device.type),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "d-inline"
    }, [_c('span', {
      staticClass: "inter; font-size:1rem;"
    }, [_vm._v(_vm._s(claim_device.brand) + " " + _vm._s(claim_device.model))]), _c('br'), _vm._v(" "), _vm._l((claim_device.loss_types), function(loss_type) {
      return _c('small', {
        key: loss_type.id,
        staticClass: "f6 silver inter"
      }, [(loss_type.name == 'Other') ? _c('span', [_vm._v(_vm._s(loss_type.loss_type_category) + " - ")]) : _vm._e(), _vm._v(_vm._s(loss_type.name) + "\n                ")])
    })], 2)]), _vm._v(" "), _vm._m(1, true)])])])
  })], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "f5 mb2 color-theme title-responsive"
  }, [_vm._v("\n              View Details\n              "), _c('img', {
    staticClass: "mr1",
    attrs: {
      "src": "/static/icons/ic_greater_than_right.svg",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hov toggle-info pt-30"
  }, [_c('img', {
    staticClass: "mr1",
    attrs: {
      "src": "/static/icons/ic_greater_than_right_grey.svg",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5e317ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClaimCardV2.vue
// module id = 1394
// module chunks = 0